module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_19-ea292b9f85c61a030a9a6c48e3646c24.jpg";